// extracted by mini-css-extract-plugin
module.exports = {"resultsWrapper":"styles_resultsWrapper__1t1IQ","matchList":"styles_matchList__3Cxkz"};